export default __webpack_public_path__ + "static/media/Car2.e3d22a07.jpg";